'use client'

import { toast } from '@/core/lib/toast'

import UnlockModal from '@/features/veluvit/components/collection/unlock-modal'
import { go } from '@/features/veluvit/lib/navigation'
import { ensureAccount } from '@/features/veluvit/services/session.service'
import { closeAll, openModal } from '@/features/veluvit/stores/overlay.store'

/* 컬렉션 동작 — 레퍼런스 openUnlock / doUnlock(v2 서버 해금) / sceneChat. 시크릿 컬렉션(openSecret)은 없어진 기획이라 뺐다(2026-10-07) */

export function openUnlock(workId: string, index: number) {
  openModal(<UnlockModal workId={workId} index={index} />, {
    label: '장면 해금',
  })
}

/** 이 장면으로 대화하기 — 해당 장소로 옮겨서 대화방을 연다 */
export async function sceneChat(workId: string, place: string) {
  try {
    await ensureAccount()
    closeAll()
    go(`/chat/${workId}?scene=${encodeURIComponent(place)}`)
  } catch (error) {
    toast.show(
      error instanceof Error ? error.message : '연결을 확인해 주세요.',
      { duration: 3200 }
    )
  }
}
